export default {
	id: 'b14183fc-884e-4011-8ce6-fc4a2585644a',
	icon: 'mdi-flip-horizontal',
	name: 'flipCard',
	title: 'Flip Card',
	description: 'A FlipCard component',
	deprecated: 'Deprecated'
};
